import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const WithStepperImages = Component => {
	const Enhanced = props => {
		const images = useStaticQuery(graphql`
			query {
				allFile(filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { eq: "stepper" } }) {
					edges {
						node {
							name
							childImageSharp {
								fluid(maxWidth: 400, quality: 100) {
									...GatsbyImageSharpFluid
								}
							}
						}
					}
				}
			}
		`)
		return <Component {...props} images={images} />
	}

	return Enhanced
}

export default WithStepperImages
